// view port size
export const GRID_BREAKPOINTS = {
  xs: 0,
  sm: 320,
  smm: 480,
  md: 576,
  lg: 992,
  mxl: 1390,
  xl: 2048,
};

export const NEW_LOGO_URL =
  'https://damassets.autodesk.net/content/dam/autodesk/logos/autodesk-logo-blk.svg';

export const LOCALE_LS = 'up-locale';

export { ROUTES } from './routes';
export { ANALYTICS, TILE_TRACK_LINK } from './analytics';
export { FALLBACK_FLAGS, FLAG_NAMES } from './featureFlags';
export { default as UH_EVENTS } from './uhClickEvents';
export const MAXIMUM_NUMBER_OF_ENTITIES = 102;
export { adpAnalyticsEvents } from './adpAnalyticsEvents';
export { AUTH_SCOPE } from './auth';

export const PRIVACY_COOKIES_URL =
  'https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement';
export const TERMS_OF_USE_URL =
  'https://www.autodesk.com/company/legal-notices-trademarks/access-use/website-terms-of-use';
